import { useCallback, useEffect, useId, useRef } from 'react';
import { useBarcodeScanner } from '../../../provider/scanner/BarcodeScannerContext';

type UseScannerTargetOptions = {
    enabled?: boolean;
    onScan: (barcode: string) => void | Promise<void>;
};

export const useScannerTarget = ({ enabled = true, onScan }: UseScannerTargetOptions) => {
    const id = useId();
    const onScanRef = useRef(onScan);

    const { registerTarget, setActiveTargetId, clearActiveTargetId } = useBarcodeScanner();

    useEffect(() => {
        onScanRef.current = onScan;
    }, [onScan]);

    useEffect(() => {
        if (!enabled) return;

        return registerTarget(id, (barcode) => {
            return onScanRef.current(barcode);
        });
    }, [enabled, id, registerTarget]);

    const activateScannerTarget = useCallback(() => {
        if (!enabled) return;
        setActiveTargetId(id);
    }, [enabled, id, setActiveTargetId]);

    const deactivateScannerTarget = useCallback(() => {
        clearActiveTargetId(id);
    }, [clearActiveTargetId, id]);

    return {
        scannerTargetId: id,
        activateScannerTarget,
        deactivateScannerTarget,
    };
};
